import { Component, OnInit } from '@angular/core';
import {InformacionceService} from '../services/informacionce.service';
import { AlertsService } from 'angular-alert-module';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../environments/environment";



@Component({
  selector: 'app-Informacionce',
  templateUrl: './informacionce.component.html',
  styleUrls: ['./informacionce.component.css']
})
export class informacionceComponent implements OnInit {

API_ENDPOINT: string ='http://'+window.location.hostname+':3001';
 pag = 1;
  zom = 1.0;
  constructor(private informacionceService: InformacionceService, private httpClient: HttpClient) { }
pdfSrc = ""; 


  


  ngOnInit() {
 
  }



}
